import JelledSwitch from 'components/JelledSwitch'
import { useTheme } from '@mui/material'
import { getElementColor } from 'utils/darkMode'

const StreamingSwitch = ({
  isStreamingToggled,
  setIsStreamingToggled,
  isDarkBackdrop,
}: {
  isStreamingToggled: boolean
  setIsStreamingToggled: React.Dispatch<React.SetStateAction<boolean>>
  isDarkBackdrop: boolean // used to conditionally style label text color, sometimes this component is on a light / dark backdrop
}) => {
  const theme = useTheme()
  const onStreamingToggleChange = async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setIsStreamingToggled(checked)
  }

  return (
    <JelledSwitch
      label={`Use streaming api`}
      checked={isStreamingToggled}
      onChange={onStreamingToggleChange}
      style={{
        width: '240px',
        color: getElementColor(isDarkBackdrop, theme),
      }}
    />
  )
}

export default StreamingSwitch
